import React from 'react';
import {
  ChakraProvider,
  extendTheme,
} from '@chakra-ui/react';

import { Routes, Route } from "react-router-dom";

// styles
import './app.scss'
import './animations.scss'

// Pages
import Home from './pages/Home'
import Login from './pages/Login'
import Join from './pages/Join'
import Learn from './pages/Learn'
import Experiences from './pages/Experiences'
import About from './pages/About'

// Components
import NavBar from './components/navBar/Navbar'
import Footer from './components/footer/Footer'

const theme = extendTheme({
  colors: {
    brand: {
      main: "#50CBC2", // Brand colour
      light: "#AACBC9", // Light brand colour (hoverstate - subtle)
      dark: "#00A8A0", // Darker brand colour (hoverstate)
      black: "#262626",
    },
  },
})

function App() {
  return (
    <ChakraProvider theme={theme}>
      <NavBar />
      <div style={{ marginTop: '60px' }}>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/join" element={<Join />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/about" element={<About />} />
        </Routes>
      </div>
      <Footer />
    </ChakraProvider>
  );
}

export default App;
